 const firebaseConfig =  {
    apiKey: "AIzaSyAuOf94KCcW2oTI3gUitSD35tWsPggP0Z0",
    authDomain: "openquiz-29cc5.firebaseapp.com",
    databaseURL: "https://openquiz-29cc5.firebaseio.com",
    projectId: "openquiz-29cc5",
    storageBucket: "openquiz-29cc5.appspot.com",
    messagingSenderId: "164997608299",
    appId: "1:164997608299:web:356365bf263b879e7a122e",
    measurementId: "G-BVJGHYMEWD"
  }


  export default firebaseConfig;